import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const InvoiceErrorInternationalStepConfig: StepConfig = {
    type: FormType.INVOICE_ERROR_INTERNATIONAL
};
